/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
/* eslint-disable import/named */
/* eslint-disable prefer-const */
import axios from 'axios';
import { forceLogin, shouldForceLogin } from '@/js/forceLogin';
import { getLocalizedAuthOrLicenseResponseMessage } from '@/js/licenseMessage';
// import {
//   SystemAuthRemoveTokenDel,
// } from '@/js/api/system';
// import { useI18n } from '@/js/i18n';

const request = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_BASE_URL
      : `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_BASE_URL}`,
  headers: { 'content-type': 'application/json' },
  withCredentials: true,
});

request.interceptors.request.use((config) => {
  config.headers['X-Access-tokens'] = JSON.parse(sessionStorage.getItem('token'))?.token || '';
  // if (config.url.indexOf('/operation/training_set') > -1 && config.method === 'post') {
  //   config.headers['content-type'] = 'multipart/form-data';
  // }
  // //
  // if (config.url.indexOf('/operation/prediction_set') > -1 && config.method === 'post') {
  //   config.headers['content-type'] = 'multipart/form-data';
  // }
  // //
  // if (config.url.indexOf('/uploads/table/content') > -1 && config.method === 'post') {
  //   config.headers['content-type'] = 'multipart/form-data';
  // }
  //
  return config;
});
request.interceptors.response.use(
  (response) => {
    // console.log(response);
    return response;
  },
  (error) => {
    // console.log('[HTTP ERROR] request.interceptors');
    // console.log(error.response.data);
    // const i18n = useI18n();
    const authOrLicenseMsg = getLocalizedAuthOrLicenseResponseMessage(error);
    if (authOrLicenseMsg) {
      if (error.response) {
        error.response.skipError = true;
      } else {
        error.skipError = true;
      }
    }

    const forceLoginNeeded = shouldForceLogin(error);
    if (!forceLoginNeeded) return Promise.reject(error.response || error);

    forceLogin({ error });

    return Promise.reject(error.response || error);
  },
);

export const NormalGet = (module, url, data) => {
  const p = [];
  if (data) {
    Object.keys(data).forEach((key) => {
      // p.push(`${key}=${encodeURI(data[key] ? data[key].toString() : '').replace(/#/g, '%23').replace(/&/g, '%26')}`);
      const encodedKey = encodeURI(key);
      const encodedValue = encodeURI(
        data[key] === null || data[key] === undefined ? '' : data[key].toString(),
      )
        .replace(/\+/g, '%2B')
        .replace(/#/g, '%23')
        .replace(/&/g, '%26');
      p.push(`${encodedKey}=${encodedValue}`);
    });
  }
  const parms = p.length ? `?${p.join('&')}` : '';
  return request.get(`${module}${url}${parms}#${new Date().getTime()}`);
};

export const NormalPost = (module, url, data) => {
  const postData = data ? JSON.stringify(data) : '';
  return request.post(`${module}${url}#${new Date().getTime()}`, postData);
};

export const NormalPut = (module, url, data) => {
  const putData = data ? JSON.stringify(data) : '';
  return request.put(`${module}${url}#${new Date().getTime()}`, putData);
};

export const NormalDelete = (module, url, data) => {
  return request.delete(`${module}${url}#${new Date().getTime()}`, { data });
};

export default request;
